import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GenericCrudEditComponent } from 'src/app/libs/components/generic-crud/generic-crud-edit.component';
import { Checkpoint, TId, WorkProcedure, WorkProcedureStep } from 'src/app/models';
import { GenericResource } from 'src/app/resources';
import { StepsAddComponent } from '../../../../../../../../aps/aps-configuration/work-procedures/steps-add/steps-add.component';
import { StepsEditComponent } from '../../../../../../../../aps/aps-configuration/work-procedures/steps-edit/steps-edit.component';

@Component({
  selector: 'app-work-procedure-edit',
  templateUrl: './work-procedure-edit.component.html',
  styleUrl: './work-procedure-edit.component.sass',
  standalone: false,
})
export class WorkProcedureEditComponent extends GenericCrudEditComponent<WorkProcedure> {
  @Input() workProcedure?: WorkProcedure;
  override resource = this.api.resources.product.workProcedures;

  stepsAddComponent = StepsAddComponent;
  stepsEditComponent = StepsEditComponent;
  steps?: GenericResource<WorkProcedureStep>;
  checkpoints: Checkpoint[] = [];

  protected override async preFetch(): Promise<void> {
    this.entity = this.workProcedure!;
    this.steps = this.api.resources.product.workProceduresSteps(this.entity!.id);
    this.checkpoints = await firstValueFrom(this.api.resources.checkpoints.getAll());
  }

  override initFormGroup(): FormGroup<any> {
    return this.fb.group({
      id: [this.entity?.id],
      name: [this.entity?.name],
      code: [this.entity?.code],
      companyId: [this.entity?.companyId],
    });
  }

  override displayEntity(): string | [string, string] | { title: { text: string; icon?: string; color?: string; }; subtitle?: { text: string; icon?: string; color?: string; }; } {
    return { title: { text: this.entity?.code + ' ' + this.entity?.name } };
  }

  getCheckpointName(id: TId | undefined): string {
    if (id == null || id === '') {
      return '';
    }
    return this.checkpoints.find(c => c.id === id)?.name ?? '';
  }

  formatDefaultValues(value: unknown): string {
    if (value == null) {
      return '';
    }
    if (Array.isArray(value)) {
      return value.map(String).join(', ');
    }
    return String(value);
  }
}
